import { Component, HostBinding } from "@angular/core";

@Component({
	standalone: false,
	selector: "slider-item-web-ay",
	template: `<ng-content></ng-content>`,
})
export class SlideItemWebAyComponent {
	@HostBinding("class") class = "swiper-slide";
}
